import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { dataLayer } from '@weatherbug/common';
import { IStdParameters, Response } from '../utilities/interfaces';
import { IStoreState } from '../utilities/storeStateInterface';

const processIconWidgetTemplate = (iconCode: string, iconSize: string, iconSet: string,  iconApiResponse: Response) => {
    let imgSource = getUrlFromResponse(iconApiResponse);
    imgSource = imgSource?.replace('{iconSet}', iconSet);
    imgSource = imgSource?.replace('{iconCode}', iconCode);
    imgSource = imgSource?.replace('{iconSize}', iconSize);

    return imgSource;
};

const getUrlFromResponse = (response: Response): string | undefined => {
    if (!response?.Resources?.[0]) {
        return;
    }
    try {
        const resource = response.Resources[0];
        const responseBaseURL = new URL(resource?.Url);
        const params = resource?.Parameters;

        params?.forEach((queryParamItem: any) => {
            const queryParamItemKey = queryParamItem?.Key;
            const queryParamItemValue = queryParamItem?.Value;
            responseBaseURL.searchParams.append(queryParamItemKey, queryParamItemValue);
        })

        const resultURL = decodeURIComponent(responseBaseURL.toString());

        return resultURL;
    } catch(error) {
        console.error('Error generating URL from response', error);
        return;
    }
};


const mapStoreStateToProps = (storeState: IStoreState, ownProps: IconWidgetType) => {
    const { contentManagementTemplate } = storeState;
    const {iconCode, iconSize, iconSet} = ownProps;

    if (!contentManagementTemplate?.iconTemplate && !iconCode && !iconSet && !iconSize) {
        return;
    }

    const iconApiResponse = contentManagementTemplate?.iconTemplate!;

    return {
        iconApiResponse
    };
};

const mapDispatchToProps = {
    getContentManagementTemplate: dataLayer?.actions?.getContentManagementTemplate
};

interface IconWidgetType {
    iconApiResponse: Response;
    getContentManagementTemplate: (
        baseUrl: string, 
        authId: string, 
        secret: string, 
        verbose: boolean, 
        stdParams: IStdParameters, 
        resourceList: string
    ) => void;
    url: string;
    iconCode: string;
    iconSet: string;
    iconSize: string;
    contentManagementBaseUrl: string;
    authId: string;
    secret: string;
    stdParameters: IStdParameters;
    resourceList: string;
}

export const IconWidget = connect(mapStoreStateToProps, mapDispatchToProps) (({
    iconApiResponse,
    getContentManagementTemplate,
    iconCode,
    iconSet,
    iconSize,
    contentManagementBaseUrl,
    authId,
    secret,
    stdParameters,
    resourceList
}: IconWidgetType) =>  {
    const initialLoadComplete = useRef(false);
    const url = processIconWidgetTemplate(iconCode, iconSize, iconSet, iconApiResponse)!;

    const tryLoadInitialData = async() => {
        if (!initialLoadComplete.current && contentManagementBaseUrl && authId && secret && resourceList) {
            try {
                initialLoadComplete.current = true;

                await getContentManagementTemplate(
                    contentManagementBaseUrl,
                    authId,
                    secret,
                    true,
                    stdParameters,
                    resourceList);
            } catch (error) {
                console.log(error);
            }
        }
    }

    useEffect(() => {
        initialLoadComplete.current = false;
        tryLoadInitialData();
    }, [contentManagementBaseUrl, resourceList, secret, authId]);

    return (
        <img alt='Weather forecast icon' className='wb-content-mgt-icon-image' src={url}/>
    );
});
